module.exports = __webpack_public_path__ + "static/media/paper-background.809a9ced.webp";